<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead class="border-0">
                <tr>
                  <th style="width: 10%" class="border-0">
                    {{ $t("RequesterName") }}
                  </th>
                  <th style="width: 10%" class="border-0">
                    {{ $t("RequesterUsername") }}
                  </th>
                  <th style="width: 10%" class="border-0">
                    {{ $t("Departman") }}
                  </th>
                  <th style="width: 10%" class="border-0">
                    {{ $t("Supplier") }}
                  </th>
                  <th style="width: 5%" class="border-0">
                    {{ $t("CurrencyType") }}
                  </th>
                  <th style="width: 13%" class="border-0">
                    {{ $t("DeliveryDate") }}
                  </th>
                  <th style="width: 13%" class="border-0">
                    {{ $t("CreateOn") }}
                  </th>
                  <th style="width: 30%" class="border-0">
                    {{ $t("Description") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td  class="border-0">
                    {{ model.requesterInfo ? model.requesterInfo.name : "-" }}
                  </td>
                  <td class="border-0">
                    {{
                      model.requesterInfo ? model.requesterInfo.userName : "-"
                    }}
                  </td>
                  <td class="border-0">
                    {{ model.departmentUnit ? model.departmentUnit.name : "-" }}
                  </td>
                  <td class="border-0">
                    {{
                      model.supplierInfo ? model.supplierInfo.supplierName : "-"
                    }}
                  </td>
                  <td class="border-0">
                    {{
                      model.currencyType === 1
                        ? "ریال"
                        : model.currencyType === 2
                        ? "دلار"
                        : model.currencyType === 3
                        ? "درهم"
                        : "-"
                    }}
                  </td>
                  <td class="border-0">
                    {{
                      model.persianDeliveryClock
                        ? model.persianDeliveryClock
                        : "-"
                    }}
                  </td>

                  <td class="border-0">
                    {{ model.persianCreateOn ? model.persianCreateOn : "-" }}
                  </td>

                  <td class="border-0">
                    {{ model.description ? model.description : "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mt-5">
      <div class="vx-card__body card-body">
        <h3>
          {{ $t("PurchaseOrder") }}
        </h3>
        <div class="vx-row mt-5">
          <div class="vx-col w-full mb-base">
            <vs-table
              :data="model.purchaseOrderItems"
              class="custom-tbl"
              id="colored-table"
            >
              <template slot="thead">
                <th style="width: 5%">#</th>
                <th style="width: 10%">{{ $t("ProductName") }}</th>
                <th style="width: 10%">{{ $t("ModelNumber") }}</th>
                <th style="width: 10%">{{ $t("ItemCode") }}</th>
                <th style="width: 10%">{{ $t("Unit") }}</th>
                <th style="width: 10%">{{ $t("Count") }}</th>
                <!-- <th style="width: 10%">{{ $t("EffectiveAmount") }}</th> -->
                <th style="width: 10%">{{ $t("UnitPrices") }}</th>
                <th style="width: 10%">{{ $t("AmountSourceCurrencyWithDeduction") }}</th>
                <th style="width: 10%">{{ $t("TotalAmount") }}</th>
                <!-- <th style="width: 10%">{{ $t("Action") }}</th> -->
              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="(row, index) in data" :key="index">
                  <vs-td>
                    {{ index + 1 }}
                  </vs-td>
                  <vs-td style="width: 20%">
                    {{ row.purchaseOrderProductInfo.name }}
                  </vs-td>
                  <vs-td style="width: 10%">
                    {{ row.purchaseOrderProductInfo.modelNumber }}
                  </vs-td>
                  <vs-td style="width: 10%">
                    {{ row.purchaseOrderProductInfo.itemCode }}
                  </vs-td>
                  <vs-td>
                    {{ row.unitOfMeasure.name }}
                  </vs-td>
                  <vs-td>
                    {{ row.count }}
                  </vs-td>
                  <!-- <vs-td style="direction: ltr">
                    {{ formatPrice(row.purchaseOrderEffectiveAmount) }}
                  </vs-td> -->
                  <vs-td>
                    {{ row.unitPrice ? formatPrice(row.unitPrice) : "-" }}
                  </vs-td>
                  <vs-td>
                    {{ row.unitPriceAfterDeductionAndIncrease ? formatPrice(row.unitPriceAfterDeductionAndIncrease) :'-'}}
                  </vs-td>
                  <vs-td style="width: 10%">
                    {{ formatPrice(row.amount) }}
                  </vs-td>
                  <!-- <vs-td>
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="deleteProduct(index)"
                      class="d-inline"
                    ></vs-button>
                  </vs-td> -->
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
        <div class="flex justify-end mt-3 w-full">
          <table class="basic-tbl w-1/5 total" id="colored-table">
            <thead class="border-0">
              <tr>
                <th style="width: 10%">{{ $t("TotalAmount") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="width: 10%" class="border-0">
                  {{ model.totalAmount ? formatPrice(model.totalAmount) : "-" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div
      v-if="model.purchaseOrderDeductionAndIncrease.length > 0"
      class="vx-card mt-5"
    >
      <div class="vx-card__body card-body">
        <h3>
          {{ $t("DeductionAndIncrease") }}
        </h3>
        <div class="vx-row mt-5">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead class="z-0 relative">
                <tr>
                  <th style="width: 5%">#</th>
                  <th style="width: 10%">
                    {{ $t("DeductionAndIncreaseType") }}
                  </th>
                  <th style="width: 10%">{{ $t("ToleranceType") }}</th>
                  <th style="width: 10%">{{ $t("Amounts") }}</th>
                  <th style="width: 10%">{{ $t("Description") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(
                    row, index
                  ) in model.purchaseOrderDeductionAndIncrease"
                >
                  <td>{{ index + 1 }}</td>
                  <td style="width: 10%">
                    <div>
                      {{
                        row.deductionAndIncreaseType &&
                        row.deductionAndIncreaseType === 1
                          ? "کسر"
                          : "اضافه"
                      }}
                    </div>
                  </td>
                  <td style="width: 10%">
                    <div>
                      {{
                        row.toleranceType && row.toleranceType === 1
                          ? "درصدی"
                          : "مقداری"
                      }}
                    </div>
                  </td>

                  <td style="width: 10%">
                    <div>
                      {{ row.amount ? formatPrice(row.amount) : "-" }}
                    </div>
                  </td>
                  <td style="width: 30%">
                    <div>
                      {{ row.description ? row.description : "-" }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-end w-full ml-4 mt-10">
      <vs-button
        type="filled"
        color="danger"
        v-has-permission="'GotoRejectPurchaseOrder'"
        @click.prevent="reject"
      >
        <span> {{ $t("Reject") }}</span>
      </vs-button>
      <vs-button
        v-has-permission="'GotoConfirmPurchaseOrder'"
        type="filled"
        color="success"
        class="mr-5"
        @click.prevent="accept"
      >
        <span> {{ $t("Confirm") }}</span>
      </vs-button>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import { mapActions } from "vuex";

export default {
  name: "warehouseManagement_CheckinTransactions_Details",
  data() {
    return {
      allUnits: [],
      headerInfo: {},
      model: {},
      editable: true,
      editClicked: false,
      productName: "",
      modelNumber: "",
      amount: 0,
      unit: {},
    };
  },

  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchPurchaseOrder: "purchaseOrder/fetchPurchaseOrder",
      acceptPurchaseOrder: "purchaseOrder/acceptPurchaseOrder",
      rejectPurchaseOrder: "purchaseOrder/rejectPurchaseOrder",
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchPurchaseOrder(id).then((r) => {
        this.model = r;
      });
    },
    formatPrice(value) {
      if (!value) return value;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    reject() {
      this.$swal({
        position: "center-center",
        text: "آیا از رد این پیش سفارش اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.rejectPurchaseOrder({ id: this.model.id }).then((r) => {
            this.$swal({
              position: "center-center",
              type: "danger",
              text: "سفارش خرید مورد نظر رد شد",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.go(-1);
            });
          });
        }
      });
    },
    accept() {
      this.$swal({
        position: "center-center",
        text: "آیا از تایید این پیش سفارش اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.acceptPurchaseOrder({ id: this.model.id }).then((r) => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "پیش سفارش مورد نظر تایید شد",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.go(-1);
            });
          });
        }
      });
    },
  },
};
</script>
<style>
body[dir="rtl"] table thead th {
  position: static;
}
.total thead {
  border: 1px solid;
}
#colored-table thead tr th{
  color: white;
}
/* .total tbody tr{
  border-top: 0 !important;
  border: 1px solid;
} */
</style>
